module.exports = __webpack_public_path__ + "static/media/Home-Detailed-Compressed.1e391097.jpg";